import { render, staticRenderFns } from "./GrantApplication.vue?vue&type=template&id=2c7133e6&scoped=true&"
import script from "./GrantApplication.vue?vue&type=script&lang=js&"
export * from "./GrantApplication.vue?vue&type=script&lang=js&"
import style0 from "./GrantApplication.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GrantApplication.vue?vue&type=style&index=1&id=2c7133e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7133e6",
  null
  
)

export default component.exports